import { createSlice } from "@reduxjs/toolkit";

const userState = { firstName: "", lastName: "", isKYC: false };

export const walletSlice = createSlice({
  name: "wallet",
  initialState: { amount: 0 },
  reducers: {
    setWalletAmount: (state, action) => {
      // if (login) {
      console.log(action.payload);
      state.amount = action.payload;
    },
    resetWallet: (state) => {
      state.amount = 0;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setWalletAmount, resetWallet } = walletSlice.actions;
export default walletSlice.reducer;
